import { render, staticRenderFns } from "./errorModal.vue?vue&type=template&id=a6bc1c32&"
import script from "./errorModal.vue?vue&type=script&lang=js&"
export * from "./errorModal.vue?vue&type=script&lang=js&"
import style0 from "./errorModal.vue?vue&type=style&index=0&id=a6bc1c32&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports